import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import PerfectScrollbar from "react-perfect-scrollbar";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtVertical from "../../../../../@coremat/CmtNavigation/Vertical";
import { getMyAccesses, hasAdminAccess } from "services/adminAccess";
import IntlMessages from "@jumbo/utils/IntlMessages";
import {
  PeopleAlt,
  Receipt,
  NewReleasesSharp,
  EventSeat,
  PermMedia,
  PanTool,
  ViewCarousel,
  VpnKey,
  Redeem,
  Score,
  NotificationsActive,
  ConfirmationNumber,
  MonetizationOn,
  Satellite,
  Gavel,
  HelpOutline,
  Spellcheck,
  PeopleOutline,
  ShoppingCart,
  AccountBalance,
  Flag,
  Map,
  Event,
  EmojiEvents,
  ScoreOutlined,
} from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  perfectScrollbarSidebar: {
    height: "100%",
    transition: "all 0.3s ease",
    ".Cmt-sidebar-fixed &, .Cmt-Drawer-container &": {
      height: "calc(100% - 167px)",
    },
    ".Cmt-modernLayout &": {
      height: "calc(100% - 72px)",
    },
    ".Cmt-miniLayout &": {
      height: "calc(100% - 91px)",
    },
    ".Cmt-miniLayout .Cmt-sidebar-content:hover &": {
      height: "calc(100% - 167px)",
    },
  },
}));

const types = [
  // Collapsible groups and their permissions, in display order.
  "Users",
  "JoftPoochManager",
  "MarathonDanaie",
  "FileManager",
  "Support",
  "PointShop",
  "UserManager",
  "JoftPooch",
  "Blog",
  "ReportCard",
  "Banner",
  "Event",
  "File",
  "Gallery",
  "MainAccessList",
  "AccessList",
  "Form",
  "SecurityToken",
  "Key",
  "Score",
  "Notification",
  "SupportTicket",
  "Coin",
  "HubbleManager",
  "Hubble",
  "WordGame",
  "Vow",
  "AdminLog",
];

const SideBar = () => {
  const classes = useStyles();
  const token = useSelector(({ auth }) => auth.token);
  const [sideNavs, setSideNavs] = useState({});
  const [accessError, setAccessError] = useState(false);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    let active = true;
    setAccessError(false);
    if (!token) return;
    const fetchAccessData = async () => {
      const navItems = [];
      const findNavItem = (name) => navItems.find((item) => item.name === name);
      const getOrCreateCollapseItem = (name, icon) => {
        let item = findNavItem(name);
        if (!item) {
          item = {
            name,
            type: "collapse",
            icon,
            children: [],
          };
          navItems.push(item);
        }
        return item;
      };

      try {
        const access = await getMyAccesses();
        if (!active) return;
        for (const type of types) {
          const typeAccess = hasAdminAccess(access, type);
          if (
            typeAccess ||
            type === "Users" ||
            type === "JoftPoochManager" ||
            type === "FileManager" ||
            type === "HubbleManager" ||
            type === "Support" ||
            type === "PointShop"
          ) {
            switch (type) {
              case "Users":
                getOrCreateCollapseItem("کاربر", <PeopleAlt />);
                break;
              case "UserManager":
                getOrCreateCollapseItem("کاربر", <PeopleAlt />).children.push({
                  name: <IntlMessages id={"pages.usersPage"} />,
                  type: "item",
                  icon: <PeopleAlt />,
                  link: "/users",
                });
                break;
              case "MarathonDanaie":
                const marthonDanieItem = getOrCreateCollapseItem(
                  "ماراتون دانایی",
                  <EmojiEvents />
                );
                marthonDanieItem.children.push({
                  name: <IntlMessages id={"pages.marathonEveventsPage"} />,
                  type: "item",
                  icon: <EmojiEvents />,
                  link: "/marathonDanie",
                });
                marthonDanieItem.children.push({
                  name: <IntlMessages id={"pages.marathonScoreManagement"} />,
                  type: "item",
                  icon: <ScoreOutlined />,
                  link: "/marathonScoreManagement",
                });
                break;
              case "MainAccessList":
                getOrCreateCollapseItem("کاربر", <PeopleAlt />).children.push({
                  name: <IntlMessages id={"pages.mainAccessList"} />,
                  type: "item",
                  icon: <PanTool />,
                  link: "/accessList",
                });
                break;
              case "AccessList":
                getOrCreateCollapseItem("کاربر", <PeopleAlt />).children.push({
                  name: <IntlMessages id={"pages.accessListManagement"} />,
                  type: "item",
                  icon: <PanTool />,
                  link: "/accessListManagment",
                });
                break;
              case "SecurityToken":
                getOrCreateCollapseItem("کاربر", <PeopleAlt />).children.push({
                  name: <IntlMessages id={"pages.eventTokenList"} />,
                  type: "item",
                  icon: <PanTool />,
                  link: "/eventTokenList",
                });
                break;
              case "JoftPoochManager":
                getOrCreateCollapseItem("جفت پوچ", <Receipt />);
                break;
              case "JoftPooch":
                const joftPoochItem = getOrCreateCollapseItem(
                  "جفت پوچ",
                  <Receipt />
                );
                joftPoochItem.children.push({
                  name: <IntlMessages id={"pages.testsPage"} />,
                  type: "item",
                  icon: <Receipt />,
                  link: "/tests",
                });
                joftPoochItem.children.push({
                  name: <IntlMessages id={"pages.quizCheats"} />,
                  type: "item",
                  icon: <HelpOutline />,
                  link: "/quizCheats",
                });
                break;
              case "Coin":
                getOrCreateCollapseItem("جفت پوچ", <Receipt />).children.push({
                  name: <IntlMessages id={"pages.coinManagement"} />,
                  type: "item",
                  icon: <MonetizationOn />,
                  link: "/coinManagement",
                });
                break;
              case "FileManager":
                getOrCreateCollapseItem("رسانه", <PermMedia />);
                break;
              case "File":
                getOrCreateCollapseItem("رسانه", <PermMedia />).children.push({
                  name: <IntlMessages id={"pages.mediaPage"} />,
                  type: "item",
                  icon: <PermMedia />,
                  link: "/media",
                });
                break;
              case "Gallery":
                getOrCreateCollapseItem("رسانه", <PermMedia />).children.push({
                  name: <IntlMessages id={"pages.gallery"} />,
                  type: "item",
                  icon: <PermMedia />,
                  link: "/gallery",
                });
                break;
              case "Support":
                getOrCreateCollapseItem("پشتیبانی", <ConfirmationNumber />);
                break;
              case "ReportCard":
                navItems.push({
                  name: "مدیر کارنامه",
                  type: "item",
                  icon: <Receipt />,
                  link: "/reportcards",
                });
                break;
              case "Blog":
                navItems.push({
                  name: <IntlMessages id={"pages.newsPage"} />,
                  type: "item",
                  icon: <NewReleasesSharp />,
                  link: "/news",
                });
                break;
              case "Banner":
                navItems.push({ name: "اسلایدشو دسکتاپ", type: "item", icon: <ViewCarousel />, link: "/desktop-slides" });
                navItems.push({
                  name: <IntlMessages id={"pages.bannersPage"} />,
                  type: "item",
                  icon: <ViewCarousel />,
                  link: "/banners",
                });
                break;
              case "Event":
                navItems.push({
                  name: <IntlMessages id={"pages.eventsPage"} />,
                  type: "item",
                  icon: <EventSeat />,
                  link: "/events",
                });
                break;
              case "Form":
                navItems.push({
                  name: <IntlMessages id={"pages.forms"} />,
                  type: "item",
                  icon: <Receipt />,
                  link: "/forms",
                });
                break;
              case "Key":
                navItems.push({
                  name: <IntlMessages id={"pages.keyManagement"} />,
                  type: "item",
                  icon: <VpnKey />,
                  link: "/keyManagement",
                });
                break;
              // case "PointShop":
              //   getOrCreateCollapseItem("جفت پوچ", <Receipt />)
              //     .children.push({
              //       name: <IntlMessages id={"pages.pointShop"} />,
              //       type: "item",
              //       icon: <Redeem />,
              //       link: "/pointShop",
              //     });
              //   break;
              case "Score":
                getOrCreateCollapseItem("جفت پوچ", <Receipt />).children.push({
                  name: <IntlMessages id={"pages.scoreManagement"} />,
                  type: "item",
                  icon: <Score />,
                  link: "/scoreManagement",
                });
                break;
              case "Notification":
                getOrCreateCollapseItem(
                  "پشتیبانی",
                  <ConfirmationNumber />
                ).children.push({
                  name: <IntlMessages id={"pages.notifications"} />,
                  type: "item",
                  icon: <NotificationsActive />,
                  link: "/notifications",
                });
                break;
              case "SupportTicket":
                getOrCreateCollapseItem(
                  "پشتیبانی",
                  <ConfirmationNumber />
                ).children.push({
                  name: <IntlMessages id={"pages.tickets"} />,
                  type: "item",
                  icon: <ConfirmationNumber />,
                  link: "/tickets",
                });
                break;
              case "HubbleManager":
                getOrCreateCollapseItem("هابل", <Satellite />);
                break;
              case "Hubble":
                const hubbleItem = getOrCreateCollapseItem(
                  "هابل",
                  <Satellite />
                );
                hubbleItem.children.push({
                  name: <IntlMessages id={"pages.hubble"} />,
                  type: "item",
                  icon: <Satellite />,
                  link: "/hubble",
                });
                hubbleItem.children.push({
                  name: <IntlMessages id={"pages.hubbleJudge"} />,
                  type: "item",
                  icon: <Gavel />,
                  link: "/judges",
                });
                hubbleItem.children.push({
                  name: <IntlMessages id={"pages.hubbleReferee"} />,
                  type: "item",
                  icon: <Gavel />,
                  link: "/hubbleReferee",
                });
                break;
              case "WordGame":
                const wordGameItem = getOrCreateCollapseItem(
                  "کلمه بازی",
                  <Spellcheck />
                );
                wordGameItem.children.push({
                  name: <IntlMessages id={"pages.wordGameEvents"} />,
                  type: "item",
                  icon: <Event />,
                  link: "/wordGame/events",
                });
                wordGameItem.children.push({
                  name: <IntlMessages id={"pages.manageWords"} />,
                  type: "item",
                  icon: <Spellcheck />,
                  link: "/wordGame/manageWords",
                });
                wordGameItem.children.push({
                  name: <IntlMessages id={"pages.participants"} />,
                  type: "item",
                  icon: <PeopleOutline />,
                  link: "/wordGame/participants",
                });
                break;
              case "PointShop":
                const pointShopItem = getOrCreateCollapseItem(
                  "ویترین جوایز",
                  <Redeem />
                );
                // Do not load submenus if permission is denied
                if (!typeAccess) break;
                pointShopItem.children.push({
                  name: <IntlMessages id={"pages.pointShop"} />,
                  type: "item",
                  icon: <Redeem />,
                  link: "/pointShop",
                });
                pointShopItem.children.push({
                  name: <IntlMessages id={"pages.point"} />,
                  type: "item",
                  icon: <MonetizationOn />,
                  link: "/point",
                });
                pointShopItem.children.push({
                  name: <IntlMessages id={"pages.pointBank"} />,
                  type: "item",
                  icon: <AccountBalance />,
                  link: "/pointBank",
                });
                pointShopItem.children.push({
                  name: <IntlMessages id={"pages.purchases"} />,
                  type: "item",
                  icon: <ShoppingCart />,
                  link: "/purchases",
                });
                break;
              case "Vow":
                const rbItem = getOrCreateCollapseItem(
                  "روضه راه بهشت",
                  <Flag />
                );
                rbItem.children.push({
                  name: <IntlMessages id={"pages.rb1404"} />,
                  type: "item",
                  icon: <Flag />,
                  link: "/vow",
                });
                break;
              case "AdminLog":
                navItems.push({
                  name: <IntlMessages id={"pages.adminLog"} />,
                  type: "item",
                  icon: <Map />,
                  link: "/adminLog",
                });
                break;
              default:
                break;
            }
          }
        }
        setSideNavs({
          token,
          items: navItems.filter(item => item.type !== "collapse" || item.children.length > 0)
        });
      } catch (error) {
        if (active) setAccessError(true);
      }
    };
    fetchAccessData();
    return () => { active = false; };
  }, [token, retry]);

  const navs = [
    {
      name: <IntlMessages id={"sidebar.main"} />,
      type: "section",
      children: sideNavs.token === token ? sideNavs.items || [] : [],
    },
  ];

  return (
    <PerfectScrollbar className={classes.perfectScrollbarSidebar}>
      {accessError && <Alert severity="error" action={
        <Button color="inherit" size="small" onClick={() => setRetry(value => value + 1)}>تلاش دوباره</Button>
      }>دریافت دسترسی‌ها ممکن نشد.</Alert>}
      <CmtVertical menuItems={navs} />
    </PerfectScrollbar>
  );
};

export default SideBar;
